/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Cidr
 */
export interface Cidr {
}

/**
 * Check if a given object implements the Cidr interface.
 */
export function instanceOfCidr(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CidrFromJSON(json: any): Cidr {
    return CidrFromJSONTyped(json, false);
}

export function CidrFromJSONTyped(json: any, ignoreDiscriminator: boolean): Cidr {
    return json;
}

export function CidrToJSON(value?: Cidr | null): any {
    return value;
}

